module.exports = __webpack_public_path__ + "img/telegram-brands.0026d33b.svg";